<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto input-group">
<!--                <input aria-label="Search"-->
<!--                       class="form-control"-->
<!--                       type="search"-->
<!--                       v-model="search_text"/>-->
<!--                &nbsp-->
                <multiselect
                    v-model="search_text"
                    :options="optionEmployee"
                    track-by="id"
                    :customLabel="customLabel"
                    :show-labels="false"
                    class="form-control"
                    style="border: 0"
                    placeholder="ค้นหาผู้ใช้งาน">
                </multiselect>
                &nbsp
                <button @click="search_user"
                        class="btn btn-success my-2 my-sm-0"
                        type="button">
                    <icon name="search"></icon>
                    ค้นหา
                </button>
                &nbsp
                <router-link to="/user-information">
                    <button
                        class="btn btn-primary my-2 my-sm-0"
                        type="button">
                        <icon name="plus"></icon>
                        เพิ่มผู้ใช้งาน
                    </button>
                </router-link>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">ชื่อผู้ใช้งาน</th>
                    <th scope="col">รหัสผ่าน</th>
                    <th scope="col">สิทธิ์ผู้ใช้งาน</th>
                    <th scope="col">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,i) in user_list">
                    <td>{{((dataPaginate.current_page-1)*40)+(i+1)}}</td>
                    <td>{{x.name}}</td>
                    <td>{{x.username}}</td>
                    <td>{{x.password}}</td>
                    <td>{{x.role_name}}</td>
                    <td>
                        <a @click="goEdit(x.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="user_list.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getList()">
            </vue-pagination>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import VuePagination from "../../Pagination";
    import {domain} from "../../../util/Constants";
    import Multiselect from "vue-multiselect";

    import {
        canViewSuperAdmin
    } from "../../../util/Permissions";
    import Loading from "../../Utility/Loading";

    export default {
        name: "user-management-list",
        components: {
            Loading,
            VuePagination,
            Multiselect
        },
        data() {
            return {
                msg: '',
                status: '',
                search_text:'',
                user_list: [],
                dataPaginate: {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: 1,
                    total: 1,
                    to: 1
                },
                optionEmployee:[]
            };
        },
        created() {
            this.$store.dispatch('Users/getList').then(res => this.optionEmployee = res)
            this.getList();
        },
        computed: {
            canViewSuperAdmin,
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
            })
        },
        methods: {
            customLabel (option) {
                return `${option.username} - ${option.name}`
            },
            goEdit(id) {
                this.$router.push({
                    name: 'user-information',
                    params: {id}
                })
            },
            showLoadingModal() {
                this.$refs.loading.show();
            },
            hideLoadingModal() {
                this.$refs.loading.hide();
            },
            getList() {
                const page = this.dataPaginate.current_page;
                this.$store.dispatch('Users/get', {page:page,text:this.search_text?this.search_text:""}).then(res => {
                    this.user_list = res.data
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    };
                });
            },
            search_user(){
                const page = this.dataPaginate.current_page;

                this.$store.dispatch('Users/get', {page:page,text:this.search_text?this.search_text.username:""}).then(res => {
                    this.user_list = res.data
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    };
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>
